import { render, staticRenderFns } from "./scrolltable_new.vue?vue&type=template&id=24873433&scoped=true"
import script from "./scrolltable_new.vue?vue&type=script&lang=ts"
export * from "./scrolltable_new.vue?vue&type=script&lang=ts"
import style0 from "./scrolltable_new.vue?vue&type=style&index=0&id=24873433&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24873433",
  null
  
)

export default component.exports